<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisibleSearchPegawai()"
                                @blur="toggleCloseVisibleSearchPegawai()"
                                v-model="querySearchPegawai"
                                v-text="selectedItemSearchPegawai ? selectedItemSearchPegawai['text'] : ''"
                                @keydown.up="upSearchPegawai"
                                @keydown.down="downSearchPegawai"
                                @keydown.enter="selectItemSearchPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visibleSearchPegawai">
                            <div class="options" v-if="matchesSearchPegawai.length != 0 && querySearchPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesSearchPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedSearchPegawai == index)}"
                                    @click="itemClickedSearchPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesSearchPegawai.length == 0 && querySearchPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesSearchPegawai.length == 0 && querySearchPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <img class="mr-4 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menghapus data?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Pegawai</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    v-if="tipe != 'C'"
                                    disabled
                                    v-model.trim="$v.queryPegawai.$model"
                                    :class="{ 'is-invalid':$v.queryPegawai.$error, 'is-valid': !$v.queryPegawai.$invalid }"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <input type="text"
                                    class="form-control"
                                    v-else
                                    @click="toggleVisiblePegawai()"
                                    @blur="toggleCloseVisiblePegawai()"
                                    v-model.trim="$v.queryPegawai.$model"
                                    :class="{ 'is-invalid':$v.queryPegawai.$error, 'is-valid': !$v.queryPegawai.$invalid }"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawai">
                                <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawai == index)}"
                                        @click="itemClickedPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Induk Pegawai</label>
                        <input 
                            class="form-control"
                            :disabled="disNip"
                            v-model.trim="$v.nip.$model"
                            :style="{'background-color:whitesmoke':disNip == true}"
                            :class="{ 'is-invalid':$v.nip.$error, 'is-valid': !$v.nip.$invalid }"
                            placeholder="Nomor Induk Pegawai" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Nomor Induk Kependudukan (NIK)</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.ktp.$model"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            :class="{ 'is-invalid':$v.ktp.$error, 'is-valid': !$v.ktp.$invalid }"
                            placeholder="Nomor Induk Kependudukan" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>ID Vaksin</label>
                        <input 
                            class="form-control" 
                            v-model="idVaksin"
                            placeholder="ID Vaksin" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow class="mb-2 mt-5">
                    <CCol sm="12">
                        <span class="font-weight-bold" style="font-size: 16px;color:black">Data Vaksin Pertama</span>
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Tanggal Vaksin Pertama</label>
                        <input 
                            class="form-control"
                            v-model="tanggalVaksinPertama"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tempat Vaksin Pertama</label>
                        <textarea 
                            class="form-control"
                            v-model="tempatVaksinPertama"
                            placeholder="Tempat Vaksin Pertama"
                        />
                    </CCol>
                </CRow>
                <CRow class="mb-2 mt-5">
                    <CCol sm="12">
                        <span class="font-weight-bold" style="font-size: 16px;color:black">Data Vaksin Kedua</span>
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Tanggal Vaksin Kedua</label>
                        <input 
                            class="form-control"
                            v-model="tanggalVaksinKedua"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tempat Vaksin Kedua</label>
                        <textarea 
                            class="form-control"
                            v-model="tempatVaksinKedua"
                            placeholder="Tempat Vaksin Kedua"
                        />
                    </CCol>
                </CRow>
                 <CRow class="mb-2 mt-5">
                    <CCol sm="12">
                        <span class="font-weight-bold" style="font-size: 16px;color:black">Data Vaksin Booster</span>
                    </CCol>
                </CRow>
                <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Tanggal Vaksin Booster</label>
                        <input 
                            class="form-control"
                            v-model="tanggalVaksinBooster"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Tempat Vaksin Booster</label>
                        <textarea 
                            class="form-control"
                            placeholder="Tempat Vaksin Booster"
                            v-model="tempatVaksinBooster"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit mt-5">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipe != 'C'" @click="deleteModal = true" class="btn btn-edit-delete mr-2">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableIBC'
import {DataApi} from "../../../service/DataApi";
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

const xlsx = require('json-as-xlsx')
export default {
    components: {
        Tables
    },
    mixins: [validationMixin],
    validations: {
        queryPegawai: {
            required
        },
        nip: {
            required
        },
        ktp: {
            required
        }
    },
    data() {
        return {
            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Pegawai', 'NIP', 'ID Vaksin', 'Action'],
            dataTd: ['nama', 'nik', 'idVaksin', 'action'],
            styleTable: ['200px', '100px', '300px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawai: '',

            ktp: '',
            nip: '',
            disNip: false,
            tanggalVaksinPertama: '',
            tanggalVaksinKedua: '',
            tanggalVaksinBooster: '',
            tempatVaksinPertama: '',
            tempatVaksinKedua: '',
            tempatVaksinBooster: '',
            unix: '',
            tipe: 'C',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            // tanggalMulai: '',
            // tanggalSelesai: '',
            
            // data search pegawai
            dataSearchPegawai: [],
            titleSearchPegawai:"Pilih Pegawai",
            selectedItemSearchPegawai: null,
            selectedSearchPegawai: 0,
            querySearchPegawai: '',
            visibleSearchPegawai: false,
            idSearchPegawai: '',
            
            // datas
            datas: [],

            //error
            errorMessage: '',

            // delete
            deleteModal: false,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawai = ''
                this.nip = ''
                this.disNip = false
            }
            this.getDataPegawai('null')
        },
        querySearchPegawai() {
            if(this.querySearchPegawai == '') {
                this.idSearchPegawai = ''
            }
            this.flagSearch = true
            this.getDataSearchPegawai()
        },
        // tanggalMulai() {
        //     this.page = 1
        // },
        // tanggalSelesai() {
        //     this.page = 1
        // },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kodeJenis.toLowerCase() < b.kodeJenis.toLowerCase()) {
                        return -1
                    }
                    if (a.kodeJenis.toLowerCase() > b.kodeJenis.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.jenis.toLowerCase() < b.jenis.toLowerCase()) {
                        return -1
                    }
                    if (a.jenis.toLowerCase() > b.jenis.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let tanggalMulai = ''
            let tanggalSelesai = ''
            let idPegawai = this.idSearchPegawai
            let payload = {
                idPegawai: idPegawai,
                limit: limit,
                nama: "",
                pageIn: page,
                tanggalMulai: tanggalMulai,
                tanggalSelesai: tanggalSelesai
            }
            DataApi.post("pegawai/vaksin/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let limit = this.totalRow
            let page = this.page
            let tanggalMulai = ''
            let tanggalSelesai = ''
            let idPegawai = this.idSearchPegawai
            let payload = {
                idPegawai: idPegawai,
                limit: limit,
                nama: "",
                pageIn: page,
                tanggalMulai: tanggalMulai,
                tanggalSelesai: tanggalSelesai
            }
            DataApi.post("pegawai/vaksin/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Data Vaksin'
                    let data = [
                        {
                            sheet: fileName,
                            columns: [
                                { label: 'Nama', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Nomor Induk Kependudukan', value: 'noKtp' },
                                { label: 'ID Vaksin', value: 'idVaksin' },
                                { label: 'Tanggal Vaksin Pertama', value: 'tglVaksinSatu' },
                                { label: 'Lokasi Vaksin Pertama', value: 'lokasiVaksinSatu'},
                                { label: 'Tanggal Vaksin Kedua', value: 'tglVaksinDua' },
                                { label: 'Lokasi Vaksin Kedua', value: 'lokasiVaksinDua'},
                                { label: 'Tanggal Vaksin Booster', value: 'tglBooster' },
                                { label: 'Lokasi Vaksin Booster', value: 'lokasiBooster'},
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.querySearchPegawai = ''
            this.idSearchPegawai = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.queryPegawai = ''
                this.idPegawai = ''
                this.nip = ''
                this.ktp = ''
                this.idVaksin = ''
                this.disNip = false
                this.tanggalVaksinPertama = ''
                this.tanggalVaksinKedua = ''
                this.tanggalVaksinBooster = ''
                this.tempatVaksinPertama = ''
                this.tempatVaksinKedua = ''
                this.tempatVaksinBooster = ''
                this.unix = ''
                this.tipe = 'C'
                this.$v.$reset()
            }
        },
        goSave(val) {
            let tipe = ''
            if(val == 'D') {
                tipe = val
            } else {
                tipe = this.tipe
            }
            let payload = {
                idPegawai: this.idPegawai,
                idVaksin: this.idVaksin,
                lokasiBooster: this.tempatVaksinBooster,
                lokasiVaksinDua: this.tempatVaksinKedua,
                lokasiVaksinSatu: this.tempatVaksinPertama,
                noKtp: this.ktp,
                tglBooster: this.tanggalVaksinBooster,
                tglVaksinDua: this.tanggalVaksinKedua,
                tglVaksinSatu: this.tanggalVaksinPertama,
                tipe: tipe,
                unix: this.unix
            }
            DataApi.post("pegawai/vaksin/simpan", payload)
            .then(res => {
                this.deleteModal = false
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.deleteModal = false
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.nip = generate.nik
            if(this.nip != '') {
                this.disNip = true
            } else {
                this.disNip = false
            }
            this.ktp = generate.noKtp
            this.idVaksin = generate.idVaksin
            this.tanggalVaksinPertama = generate.tglVaksinSatu
            this.tanggalVaksinKedua = generate.tglVaksinDua
            this.tanggalVaksinBooster = generate.tglBooster
            this.tempatVaksinPertama = generate.lokasiVaksinSatu
            this.tempatVaksinKedua = generate.lokasiVaksinDua
            this.tempatVaksinBooster = generate.lokasiBooster
            this.unix = generate.unix
            this.getDataPegawai(generate.idPegawai)
            this.tipe = 'u'
            this.moving()
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },

        /**
         * SEARCH SEARCH PEGAWAI
         */
        getDataSearchPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.querySearchPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataSearchPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataSearchPegawai.push(onPush)
                }
            })
        },
        toggleVisibleSearchPegawai() {
            this.visibleSearchPegawai = true;
        },
        hideSearchPegawai() {
            this.visibleSearchPegawai = false;
        },
        toggleCloseVisibleSearchPegawai() {
            setTimeout(this.hideSearchPegawai, 1000);
        },
        itemClickedSearchPegawai(index) {
            this.selectedSearchPegawai = index;
            this.selectItemSearchPegawai();
        },
        selectItemSearchPegawai() {
            if (!this.matchesSearchPegawai.length) {
            return;
            }
            this.selectedItemSearchPegawai = this.matchesSearchPegawai[this.selectedSearchPegawai];
            this.visibleSearchPegawai = false;
            this.querySearchPegawai = this.selectedItemSearchPegawai.text
            this.idSearchPegawai = this.selectedItemSearchPegawai.value
            if (this.shouldReset) {
            this.querySearchPegawai = '';
            this.selectedSearchPegawai = 0;
            }
        },
        upSearchPegawai() {
            if (this.selectedSearchPegawai == 0) {
            return;
            }
            this.selectedSearchPegawai -= 1;
            this.scrollToItemSearchPegawai();
        },
        downSearchPegawai() {
            if (this.selectedSearchPegawai >= this.matchesSearchPegawai.length - 1) {
            return;
            }
            this.selectedSearchPegawai += 1;
            this.scrollToItemSearchPegawai();
        },
        scrollToItemSearchPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedSearchPegawai * this.itemHeight;
        },

        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: this.queryPegawai,
                    pageIn: 1,
                    pegawaiId: '',
                    tipePegawai: ''
                }
            } else {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    pegawaiId: val,
                    tipePegawai: ''
                }
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
                if(val != 'null') {
                    this.queryPegawai = this.dataPegawai[0].text
                    this.idPegawai = val
                    this.nip = this.dataPegawai[0].text.split(" - ")[1]
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            this.idPegawai = this.selectedItemPegawai.value
            this.nip = this.selectedItemPegawai.text.split(" - ")[1]
            this.disNip = true
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesSearchPegawai() {
            if (this.querySearchPegawai == '') {
                return [];
            }
            return this.dataSearchPegawai.filter((item) => item['text'].toLowerCase().includes(this.querySearchPegawai.toLowerCase()))
        },
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
</style>